export const productosBasculasCamiones = [
    {
        id: 301,
        categoria: 'basculas-camiones',
        nombre: 'BASCULA CONCRETO-METAL',
        descripcion: 'Balanza de Concreto-Metálica conformadas por estructuras metálicas fabricadas en nuestra planta. ',
        descripcion2: 'balanza de Concreto-Metálica conformada por marco metalico fabricado en nuestra planta. Es una balanza modular de alta resistencia, cuenta con vigas de alta calidad y hormigón de alta resistencia. Pueden ser diseñadas de acuerdo con las necesidades del cliente, donde se vierte el hormigón durante la instalación para crear la superficie de pesaje llamada plataforma. ',
        imagen: '/imagenes/productos/Camiones/concreto-metal-fundacion.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Capacidad: 20 hasta 60 toneladas ',
                'Tipo de plataforma: Metálica – Concreto ',
                
                'Instalación: Permanente / Temporal ',
                'Medidas: Según requerimientos del cliente ',
                'Sistema: Digital – Computarizado ',
                'Tipo: A Ras de piso – Sobrepiso ',
                'Clase: IP68 – Altamente resistentes al agua ',
                'Versión ATEX para zonas explosivas ',
            ]
          },
        ],
        opciones: [
          {
            id: 'concreto-foso',
            nombre: 'BAJO NIVEL',        
          },
          {
            id: 'concreto-nivel',
            nombre: 'SOBRE NIVEL',
            
          }
        ],
        imagenes: [
          '/imagenes/productos/Camiones/concreto-metal-fundacion.webp',
        ]
      },
      {
        id: 302,
        categoria: 'basculas-camiones',
        nombre: 'BASCULA METAL',
        descripcion: 'Balanza totalmente metálica conformada por estructuras metálicas, diseñadas de acuerdo a las necesidades del cliente.',
        descripcion2: 'balanza totalmente metálica conformada por estructuras metálicas, diseñadas de acuerdo a las necesidades del cliente. Una estructura con vigas de alto nivel y excelente calidad, soldadas bajo los más grandes estándares de calidad MIG hacen que las estructura tenga una resistencia inigualable a comparación de otros. Las balanzas Servibalanzas están diseñadas para adaptarse a todos los entornos, respondiendo a sus necesidades específicas: de rápida instalación, precisas, de alta calidad y alta resistencia. ',
        imagen: '/imagenes/productos/Camiones/bascula-metal-camioneta.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Capacidad: 20 hasta 60 toneladas ',
                'Tipo de plataforma: Totalmente Metálica ',
                'Instalación: Permanente / Temporal ',
                'Medidas: Según requerimientos del cliente ',
                'Sistema: Digital – Computarizado ',
                'Tipo: A Ras de piso – SobreNivel ',
                'Clase: IP68 – Altamente resistentes al agua ',
                'Versión ATEX para zonas explosivas ',
            ]
          }
        ],
        opciones: [
            {
                id: 'metal-foso',
                nombre: 'EN FOSO',
            },
            {
                id: 'metal-nivel',
                nombre: 'SOBRE NIVEL',

            }
        ],
        imagenes: [
          '/imagenes/productos/Camiones/bascula-metal-camioneta.webp',
          '/imagenes/productos/Camiones/bascula-metal-instalacion.webp',
          '/imagenes/productos/Camiones/bascula-metal-fabricacion.webp',
        ]
      },
      {
        id: 303,
        categoria: 'basculas-camiones',
        nombre: 'BASCULA PORTATIL',
        descripcion: 'Plataformas de aleación de aluminio; con un diseño pesaje ultra delgada; de fácil montaje / desmontaje.',
        descripcion2: 'Sellado herméticamente, se adapta a diferentes entornos. Funciona tanto de forma dinámica como estática. Puede usarse para medir el peso del eje y el peso total del vehículo cuando se conectan dos o cuatro plataformas de pesaje. En versión con cable o wireless. Cuenta con un indicador que tiene pantalla, teclados e impresora. ',
        imagen: '/imagenes/productos/Camiones/bascula-portatil-plataformas.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Carcasa de aluminio, panel de acero inoxidable, pantalla de ventana múltiple  ',
                'Entrada de 1 ~ 4 canales, carga por eje, peso de la rueda, peso total y porcentaje de peso  ',
                'Impresora incorporada, batería recargable opcional  ',
                'Interfaz de comunicación RS232 / RS485  ',

            ]
          }
        ],
        opciones: [
          {
            id: 'portatil-cable',
            nombre: 'PORTATIL',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Camiones/bascula-portatil-plataformas.webp',
        ]
      },
      {
        id: 304,
        categoria: 'basculas-camiones',
        nombre: 'BASCULA DINÁMICA',
        descripcion: 'El sistema ha sido diseñado conforme a los exigentes requisitos IP68: altamente resistente contra el polvo y agua. La precisión del sistema es de 0,5% o mejor en modo estático. ',
        descripcion2: 'A diferencia de las balanzas convencionales que ocupan valioso espacio en el patio y tienen plataformas pesadas que requieren extensas obras civiles, el sistema de pesaje Dinámico es una alternativa compacta, de alta resistencia, diseñada para pesar y reportar el peso de cada eje del camión, así como el peso total.',
        imagen: '/imagenes/productos/Camiones/bascula-dinamica-embutida.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Capacidad: 5 hasta 30 toneladas por eje ',
                'Precisión de 0.5 – 3.0% (Estatico y Dinamico) ',
                'Tipo de plataforma: Totalmente Metálica ',
                'Instalación: Permanente / Temporal ',
                'Sistema: Digital – Computarizado ',
                'Tipo: A Ras de piso ',
                'Clase: IP68 – Altamente resistentes al agua ',
                'Solo requiere de un mini-foso reduciendo considerablemente los gastos en Obras Civiles. ',
                'Requiere de muy poco espacio. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'dinamica',
            nombre: 'BASCULA DINÁMICA',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Camiones/bascula-dinamica-embutida.webp',
        ]
      },
      {
        id: 305,
        categoria: 'basculas-camiones',
        nombre: 'PESAJE AUTOMATIZADO',
        descripcion: 'En Servibalanzas realizamos la automatización de básculas para camiones, integrando soluciones de software diseñadas a la medida de los requerimientos de cada cliente.',
        descripcion2: 'Nuestros sistemas permiten optimizar el control y registro de pesajes, mejorando la eficiencia operativa y la trazabilidad de los procesos logísticos. La implementación incluye equipos y accesorios de última tecnología para un funcionamiento totalmente automatizado',
        imagen: '/imagenes/productos/Camiones/pesaje-automatizado-acceso.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Cámaras lectoras de patente (LPR) para identificación automática de vehículos. ',
                'Semáforos de control que regulan el ingreso y salida. ',
                'Repetidores de peso que muestran la información en tiempo real. ',
                'Sensores de posicionamiento para asegurar que el camión esté correctamente ubicado al momento del pesaje. ',
                'Tótems interactivos para el chofer, que permiten comunicación directa con el sistema. ',
                'Barreras de acceso automatizadas para un control seguro y ordenado. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'automatizado',
            nombre: 'PESAJE AUTOMATIZADO',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Camiones/pesaje-automatizado-acceso.webp',
        ]
      },
]; 
